import { BsClock, BsLightning } from 'react-icons/bs';
import { InfoIcon } from '@chakra-ui/icons';
import { Box, Flex, Grid, GridItem, Text } from '@chakra-ui/react';
import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
} from '@/components/v4';

export default function TellMeMoreModal({ isOpen, onClose, darkMode }) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="3xl">
            <ModalOverlay />
            <ModalContent bg={darkMode ? 'gray.800' : 'white'}>
                <ModalHeader
                    color={darkMode ? 'white' : 'gray.800'}
                    fontSize="lg"
                    display="flex"
                    alignItems="center"
                    gap={2}>
                    <InfoIcon color="blue.500" boxSize="18px" flexShrink={0} />
                    Understanding Upload Options
                </ModalHeader>
                <ModalCloseButton color={darkMode ? 'white' : 'gray.600'} />

                <ModalBody pb={6}>
                    <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                        {/* Create Order card */}
                        <GridItem>
                            <Box
                                border="1px solid"
                                borderColor={darkMode ? 'gray.600' : 'gray.200'}
                                borderRadius="lg"
                                p={4}
                                h="full">
                                <Flex align="center" gap={3} mb={3}>
                                    <Flex
                                        bg="blue.500"
                                        borderRadius="lg"
                                        p={2}
                                        align="center"
                                        justify="center"
                                        flexShrink={0}>
                                        <Box
                                            as={BsClock}
                                            color="white"
                                            boxSize="20px"
                                        />
                                    </Flex>
                                    <Box>
                                        <Text
                                            fontWeight="bold"
                                            color={
                                                darkMode ? 'white' : 'gray.800'
                                            }>
                                            Create Order
                                        </Text>
                                        <Box
                                            display="inline-block"
                                            bg="blue.100"
                                            color="blue.700"
                                            fontSize="10px"
                                            fontWeight="semibold"
                                            px={2}
                                            py={0.5}
                                            borderRadius="full">
                                            Recommended for Large Quantities
                                        </Box>
                                    </Box>
                                </Flex>
                                <Text
                                    fontSize="sm"
                                    color={darkMode ? 'gray.300' : 'gray.600'}>
                                    This process is asynchronous and allows you
                                    to move on to other tasks immediately.{' '}
                                    <Text as="span" fontWeight="bold">
                                        TCAP
                                    </Text>{' '}
                                    will handle the upload in the background,
                                    and you can check the order status anytime
                                    under the{' '}
                                    <Text as="span" fontWeight="bold">
                                        Orders
                                    </Text>{' '}
                                    tab.
                                </Text>
                            </Box>
                        </GridItem>

                        {/* Live Upload card */}
                        <GridItem>
                            <Box
                                border="1px solid"
                                borderColor={darkMode ? 'gray.600' : 'gray.200'}
                                borderRadius="lg"
                                p={4}
                                h="full">
                                <Flex align="center" gap={3} mb={3}>
                                    <Flex
                                        bg="gray.200"
                                        borderRadius="lg"
                                        p={2}
                                        align="center"
                                        justify="center"
                                        flexShrink={0}>
                                        <Box
                                            as={BsLightning}
                                            color="gray.500"
                                            boxSize="20px"
                                        />
                                    </Flex>
                                    <Box>
                                        <Text
                                            fontWeight="bold"
                                            color={
                                                darkMode ? 'white' : 'gray.800'
                                            }>
                                            Live Upload
                                        </Text>
                                        <Box
                                            display="inline-block"
                                            bg="gray.100"
                                            color="gray.600"
                                            fontSize="10px"
                                            fontWeight="semibold"
                                            px={2}
                                            py={0.5}
                                            borderRadius="full">
                                            Recommended for Smaller Quantities
                                        </Box>
                                    </Box>
                                </Flex>
                                <Text
                                    fontSize="sm"
                                    color={darkMode ? 'gray.300' : 'gray.600'}>
                                    Run the upload synchronously on this page.
                                    You{' '}
                                    <Text as="span" fontWeight="bold">
                                        must remain on this page
                                    </Text>{' '}
                                    while the upload completes. Progress will be
                                    displayed for each number block in real-time
                                    within the form table.{' '}
                                    <Text
                                        as="span"
                                        color="red.500"
                                        fontWeight="semibold">
                                        Please note: live uploads are not
                                        audited within Number Blocks / Orders.
                                    </Text>
                                </Text>
                            </Box>
                        </GridItem>
                    </Grid>
                </ModalBody>

                <ModalFooter>
                    <Button onClick={onClose}>Close</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
